import React, {useEffect, useRef} from 'react';
import {BalanceDeadlineMessage} from '../../features/payment/BalanceDeadlineNotice';

export default function BalanceOrderGate({deadline, employeeName, onClose, children}) {
  const locked = deadline.unavailable || deadline.data?.blocked;
  const dialog = useRef(null);
  useEffect(() => {
    if (!locked) return undefined;
    const previous = document.activeElement;
    dialog.current?.focus();
    return () => previous?.focus();
  }, [locked]);
  if (!locked) return children;

  return <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black/50 p-4" onClick={onClose}>
    <section ref={dialog} role="dialog" aria-modal="true" aria-labelledby="balance-order-title" tabIndex={-1}
      className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl" onClick={event => event.stopPropagation()}
      onKeyDown={event => {
        if (event.key === 'Escape') {event.stopPropagation(); onClose();}
        if (event.key !== 'Tab') return;
        const buttons = [...dialog.current.querySelectorAll('button')];
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.current)) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first?.focus();
        }
      }}>
      <h2 id="balance-order-title" className="text-xl font-semibold text-gray-900">Konto von {employeeName}</h2>
      <BalanceDeadlineMessage {...deadline} />
      {!deadline.data && !deadline.error && <p role="status" className="my-4 text-sm text-gray-600">Zahlungsstatus wird geprüft …</p>}
      <button type="button" onClick={onClose} className="mt-3 w-full rounded-lg bg-gray-800 px-4 py-3 font-semibold text-white hover:bg-gray-700">Schließen</button>
    </section>
  </div>;
}
